export default __webpack_public_path__ + "static/media/food_bank_purple_24px.a18393e7.svg";